"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _Timezone = _interopRequireDefault(require("../../Tools/Timezone"));

var _Address = _interopRequireDefault(require("../Address"));

var _WorkingTime = _interopRequireDefault(require("./WorkingTime"));

var _Status = _interopRequireDefault(require("./Status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Store extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "location", null);

    _defineProperty(this, "working_time", null);

    _defineProperty(this, "opened", true);

    _defineProperty(this, "status", null);

    _defineProperty(this, "published", null);

    _defineProperty(this, "timezoneOffset", -3);
  }

  static fromObject(obj) {
    let store = new Store();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'working_time':
          store.working_time = _WorkingTime.default.fromObject(value);
          break;

        case 'location':
          store.location = _Address.default.fromObject(value);
          break;

        case 'status':
          store.status = _Status.default.fromObject(value);
          break;

        case 'published':
          store.published = !!value;
          break;

        case 'opened':
          store.opened = true;
          break;

        case 'timezoneOffset':
          store.timezoneOffset = +value;
          break;

        case 'delivery_region':
          store.delivery_region = value;
          break;

        case 'keys':
          store.keys = value;
          break;
      }
    });
    return store;
  }

  static isURLValid(url) {
    if (url == '' || url.length < 5 || url.length > 20) {
      throw new Error("A url deve conter entre 5 e 20 caracteres.");
    }

    const letters = url.match(/[a-z]/g);

    if (!letters || letters.length < 3) {
      throw new Error("A url deve conter ao menos 3 letras.");
    }

    if (!url.match(/^[0-9a-z]+$/i)) {
      throw new Error("A url deve conter somente letras e números.");
    }
  }

  validate() {
    if (this.trigger('store/isOnlineOrigin')) {
      // if(this.published !== true) {
      //     throw new Error("Loja não disponível");
      // }gu
      if (!this.working_time) {
        throw new Error("Loja fechada");
      }

      if (this.status) {
        this.status.validate();
      }

      const date = new Date();

      const now = _Timezone.default.adjustTime(date, date.getTimezoneOffset() / 60, this.timezoneOffset);

      if (!this.opened || !this.working_time.isOpen(now)) {
        throw new Error("Loja fechada");
      }
    }
  }

}

exports.default = Store;